export const maskSecret = (value: string): string => {
    if (!value) return '';
    return value.length <= 4 ? '••••' : `••••${value.slice(-4)}`;
};
